// CR-7739: Admin Setup > Purchasing > Open Orders, the per site switches
// (Hide Propose Qty Ordered, Hide Communication Box): the group value and each
// site's own value. A switch not set at a level inherits (site, else group,
// else the platform value).
import api, { type AxiosResponse } from './client';

export type OpenOrdersPerSiteSwitch = 'hide_propose_qty_ordered' | 'hide_communication_box';
export type OpenOrdersSwitchSource = 'site' | 'group' | 'platform';

export interface OpenOrdersSiteRow {
  company_id: number;
  company_name: string;
  /** The site's own value; null = inherits. */
  values: Record<OpenOrdersPerSiteSwitch, boolean | null>;
  /** What the site's lines actually get, and from which level. */
  effective: Record<OpenOrdersPerSiteSwitch, { on: boolean; source: OpenOrdersSwitchSource }>;
  can_edit: boolean;
}

export interface OpenOrdersPerSiteSettings {
  organisation: { kind: 'group' | 'company'; id: number; name: string };
  switches: { key: OpenOrdersPerSiteSwitch; label: string }[];
  platform: Record<OpenOrdersPerSiteSwitch, boolean>;
  /** The group's value per switch (null = not set); null for a standalone customer. */
  group: Record<OpenOrdersPerSiteSwitch, boolean | null> | null;
  can_edit_group: boolean;
  sites: OpenOrdersSiteRow[];
  /** Helix users only: every customer organisation (`group:<id>` / `company:<id>`). */
  organisations: { key: string; name: string }[];
}

export interface OpenOrdersPerSiteUpdate {
  scope: 'group' | 'site';
  company_id?: number;
  switch: OpenOrdersPerSiteSwitch;
  /** true / false, or null to inherit. */
  value: boolean | null;
  organisation?: string;
}

const URL = '/core/settings/purchasing/open-orders-visibility/';
const orgParams = (organisation?: string) => (organisation ? { params: { organisation } } : {});

export const openOrdersSettingsAPI = {
  get: (organisation?: string): Promise<AxiosResponse<OpenOrdersPerSiteSettings>> =>
    api.get(URL, orgParams(organisation)),
  update: ({ organisation, ...data }: OpenOrdersPerSiteUpdate): Promise<AxiosResponse<OpenOrdersPerSiteSettings>> =>
    api.patch(URL, data, orgParams(organisation)),
};
